var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgHardwareIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Hardware") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Installer-Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "company-settings",
    transform: "translate(-39.000000, -332.000000)",
    fill: "#00142D"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-73",
    transform: "translate(39.000000, 332.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.3468608,3.2111286 C19.2852208,3.09038408 19.1703844,3.00763609 19.0369717,2.98568255 C18.9035589,2.963729 18.7684573,3.00848046 18.6730419,3.10389396 L16.0005643,5.76871696 L14.347259,5.76871696 L14.347259,3.99132392 L16.954719,1.31890162 C17.0476013,1.22179939 17.0906649,1.087545 17.0687109,0.954979344 C17.0467569,0.822413688 16.9640072,0.710112845 16.844949,0.646785303 C16.0166076,0.223757318 15.0818737,-2.47145299e-14 14.1395404,-2.47145299e-14 C12.5470309,-2.47145299e-14 11.0558475,0.61385498 9.93957092,1.73010847 C8.18831705,3.48217048 7.71039531,6.09464271 8.70676926,8.31870601 L0.620096999,16.3976117 C-0.204866851,17.2225585 -0.207400005,18.5558144 0.61671946,19.3807612 C1.44083893,20.2048636 2.77412236,20.2073967 3.59824183,19.3824499 L11.6764702,11.3035442 C12.4313502,11.6412911 13.2596915,11.8177638 14.0897217,11.8177638 L14.0905661,11.8177638 C15.6670323,11.8177638 17.1497719,11.2047532 18.2643597,10.0884997 C20.0856975,8.26804397 20.5197112,5.50358564 19.3468608,3.2111286",
    id: "Fill-2907"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgHardwareIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/hardware_icon.b5d3f1327ee4f0b8560b4644a492555c.svg";